import { o as onFirstInteractionIdle, W as remToPx } from "./utilities-Da0sjanJ.js";
class Sidebar extends HTMLElement {
  constructor() {
    super();
    this.sidebarItems = [];
    this.currentActiveItem = null;
    this.header = null;
    this.headerOffset = 0;
    this.handleScroll = null;
  }
  connectedCallback() {
    onFirstInteractionIdle(() => {
      this.headerOffset = remToPx(6.25);
    });
    this.initializeSidebar();
  }
  initializeSidebar() {
    const dataContentSidebar = this.getAttribute("data-sidebar-type");
    this.querySelector(".sidebar-content");
    const contentMain = document.querySelector(`[data-sidebar-content="${dataContentSidebar}"]`);
    let tagHeadingHighlight = this.getAttribute("data-tag-heading-highlight") || "h2";
    if (!contentMain) return;
    const h2Elements = contentMain.querySelectorAll(tagHeadingHighlight);
    this.bindTocItems(h2Elements);
    if (window.innerWidth > 768) {
      this.initIntersectionObserver();
    }
  }
  bindTocItems(headings) {
    this.header = this.querySelector(".sidebar-content-header");
    this.setupHeaderToggle();
    this.assignHeadingIds(headings);
    this.bindExistingItems(headings);
  }
  setupHeaderToggle() {
    if (!this.header) return;
    this.header.addEventListener("click", () => {
      this.header.classList.toggle("active");
    });
  }
  assignHeadingIds(headings) {
    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `section-${index + 1}`;
      }
    });
  }
  bindExistingItems(headings) {
    const wrapH2 = this.querySelector(".sidebar-content-list");
    if (!wrapH2) return;
    const existingItems = wrapH2.querySelectorAll(".sidebar-item");
    if (!existingItems || existingItems.length === 0) return;
    existingItems.forEach((item, index) => {
      if (index >= headings.length) return;
      const heading = headings[index];
      const link = item.querySelector(".sidebar-content-link");
      if (link) {
        this.bindLinkClick(link, heading);
      }
      this.sidebarItems.push({
        element: item,
        target: heading,
        link
      });
    });
  }
  bindLinkClick(link, heading) {
    const eventType = Shopify.designMode ? "mousedown" : "click";
    link.addEventListener(eventType, (e) => {
      e.preventDefault();
      if (window.innerWidth < 991 && this.header) {
        this.header.classList.remove("active");
      }
      this.scrollToSection(heading);
    });
  }
  scrollToSection(target) {
    const targetOffset = target.getBoundingClientRect().top + window.pageYOffset - window.innerHeight * 0.2;
    window.scrollTo({
      top: targetOffset,
      behavior: "smooth"
    });
    if (window.innerWidth > 768) {
      setTimeout(() => this.updateActiveSection(), 600);
    } else {
      setTimeout(() => this.updateActiveSection(), 300);
    }
  }
  initIntersectionObserver() {
    this.handleScroll = () => {
      this.updateActiveSection();
    };
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    onFirstInteractionIdle(() => {
      this.updateActiveSection();
    });
  }
  updateActiveSection() {
    var _a, _b;
    const scrollTop = window.pageYOffset;
    const viewportHeight = window.innerHeight;
    const scrollBottom = scrollTop + viewportHeight;
    let activeItem = null;
    let bestMatch = null;
    let maxScore = -Infinity;
    this.sidebarItems.forEach((item) => {
      const rect = item.target.getBoundingClientRect();
      const targetTop = rect.top + scrollTop;
      const targetHeight = rect.height || item.target.offsetHeight;
      const targetBottom = targetTop + targetHeight;
      const isVisible = targetBottom > scrollTop + this.headerOffset && targetTop < scrollBottom;
      if (isVisible) {
        const visibleTop = Math.max(targetTop, scrollTop + this.headerOffset);
        const visibleBottom = Math.min(targetBottom, scrollBottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibilityRatio = visibleHeight / targetHeight;
        const distanceFromTop = Math.abs(targetTop - (scrollTop + this.headerOffset));
        const score = visibilityRatio - distanceFromTop / 1e4;
        if (score > maxScore) {
          maxScore = score;
          bestMatch = item;
        }
      }
    });
    if (!bestMatch) {
      let minDistance = Infinity;
      this.sidebarItems.forEach((item) => {
        const rect = item.target.getBoundingClientRect();
        const targetTop = rect.top + scrollTop;
        if (targetTop <= scrollTop + this.headerOffset) {
          const distance = scrollTop + this.headerOffset - targetTop;
          if (distance < minDistance) {
            minDistance = distance;
            bestMatch = item;
          }
        }
      });
    }
    activeItem = bestMatch;
    if (activeItem !== this.currentActiveItem) {
      if (this.currentActiveItem) {
        this.currentActiveItem.element.classList.remove("active");
        (_a = this.currentActiveItem.link) == null ? void 0 : _a.classList.remove("active");
      }
      if (activeItem) {
        activeItem.element.classList.add("active");
        (_b = activeItem.link) == null ? void 0 : _b.classList.add("active");
      }
      this.currentActiveItem = activeItem;
    }
  }
  disconnectedCallback() {
    if (this.handleScroll) {
      window.removeEventListener("scroll", this.handleScroll);
      this.handleScroll = null;
    }
  }
}
customElements.define("sidebar-group", Sidebar);
